import {SummaryModel} from '../../../../../common/entity/summary.model';
import {PermissionsModel} from '../../../../../common/entity/permissions.model';
import {FormSummaryModel} from '../../../../../form/form/api/entity/formSummary.model';
import {Moment} from 'moment';
import {ValueAndLabelModel} from '../../../../../common/model/valueAndLabel.model';
import {TreatmentFeedbackSummaryModel} from '../../../treatment-feedback/api/models/treatment-feedback.summary.model';


export class TreatmentSummaryModel implements SummaryModel {
    permissions: PermissionsModel;
    form: FormSummaryModel;
    id: number;
    plannedStartDate: Moment;
    startDate: Moment;
    plannedEndDate: Moment;
    endDate: Moment;
    cancelDate: Moment;
    status: ValueAndLabelModel;
    lastFeedback: TreatmentFeedbackSummaryModel;
    insolesId: number;

    public static buildWithId(id: number) :TreatmentSummaryModel {
        const obj = new TreatmentSummaryModel();
        obj.id = id;
        return obj;
    }
}

export enum TreatmentPermission {
    TREATMENT_START = 'TREATMENT_START',
    TREATMENT_END = 'TREATMENT_END',
    TREATMENT_CANCEL = 'TREATMENT_CANCEL'
}

export enum TreatmentStatus {
    PLANNED = 'TREATMENT_STATUS_PLANNED',
    NOTPLANNED = 'TREATMENT_STATUS_NOT_PLANNED',
    INPROGRESS = 'TREATMENT_STATUS_IN_PROGRESS',
    ENDED = 'TREATMENT_STATUS_ENDED',
    CANCELED = 'TREATMENT_STATUS_CANCELED',
    LATE = 'TREATMENT_STATUS_LATE'
}
